<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Investigations</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('investigation create')" style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-test' }">create</router-link>
            <router-link v-if="hasPermission('investigation getSoftDeleted')" class="btn btn-success"
              :to="{ name: 'deleted-tests' }">Deleted
              test</router-link>
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="tests.length > 0">

              <MyTable :columns="columns" :actions="true">
                <tr v-for="(test, index) in filteredTests" :key="index">
                  <th scope="row">{{ test.id }}</th>
                  <td>{{ test.name_ar }}</td>
                  <td>{{ test.name_en }}</td>
                  <!-- <td>{{ test.price }}</td> -->
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('investigation delete')"
                      @click="deleteTest(test.id)">
                      Delete
                    </button>
                    <router-link v-if="hasPermission('investigation update')" class="btn btn-primary spacing"
                      :to="{ name: 'edit-test', params: { id: test.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No tests found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import { store } from "../../Store";
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "AllTests",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      tests: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        // { label: 'Price', key: 'price' },
      ],
    };
  },

  async created() {
    this.fetchTests();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },

    filteredTests() {
      if (!this.searchTerm) {
        return this.tests;
      }
      const term = this.searchTerm.toLowerCase();
      return this.test.filter(
        (test) =>
          test.name.toLowerCase().includes(term) ||
          test.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    async fetchTests() {
      try {
        const response = await axios.get(
          `/admin/admin/test/all`
        );
        this.tests = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching tests:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },

    deleteTest(id) {
      axios.delete(`/admin/admin/test/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchTests();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>